import { SearchIcon } from 'lucide-react';
import * as React from 'react';

import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export interface SearchBarProps
  extends Omit<React.ComponentProps<typeof Input>, 'type'> {
  width?: string;
}

const SearchBar = ({
  className,
  ref,
  ...props
}: { ref?: React.RefObject<HTMLInputElement | null> } & SearchBarProps) => {
  return (
    <div className={cn('relative', 'w-full')}>
      <SearchIcon className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <Input
        className={cn('pl-10', className)}
        ref={ref}
        type="text"
        {...props}
      />
    </div>
  );
};

SearchBar.displayName = 'SearchBar';

export { SearchBar };
